import ProductForm from "./product-form";
import "./pdp-tabs";
import MediaContent from "./product-media-content.jsx";
import VariantPickerContent from "./product-variant-content.jsx";
import BundleConfigContent from "./bundles/product-bundle-configuration.jsx";
import BundlePickerContent from "./product-bundle-content.jsx";
import { h, render } from "preact";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";
import "./product-details-drawer";
import "./item-count";
import "./product-video";
import "./pdp-slideshow";
import "./product-features.js";
import "./estimated-delivery/estimated-delivery.jsx";

class SectionProduct extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.mainMedia = this.querySelector("[data-product-media]");
    this.mainVariant = this.querySelector("[data-variant-picker-container]");
    this.mainBundle = this.querySelector("[data-bundle-picker-container]");
    this.mainBundleConfig = this.querySelector(
      "[data-bundle-configuration-container]",
    );
    this.group = this.data.product.tags?.find((t) => t.includes("group:"));
    this.groupSet = {};

    this.getProductGroup();
    this.productForm = new ProductForm({
      el: this,
      data: this.data,
    });
  }

  getProductGroup = async () => {
    if (!this.group) this.init();
    if (!this.group) return;
    const response = await storefront.request({
      query: queries.productsByTag(this.group),
    });
    if (response?.data?.products) {
      const products = response.data.products.edges.filter((p) => p);
      let productsClean = products.map((p) => p.node?.variants?.edges[0]),
        productOptions = productsClean.map((p) => p.node?.selectedOptions[0]);
      if (!productsClean) return;
      this.groupSet["products"] = products;
      this.groupSet["options"] = productOptions;
      this.init();
    }
  };

  init = async () => {
    if (!this.data.product) return;

    let response, configOptions;

    const updateConfigOptions = async () => {
      configOptions = await storefront.request({
        query: queries.products,
        variables: {
          ids: this.data.productsConfiguration.map((item) =>
            encodeId(item.id, "Product"),
          ),
        },
      });
    };

    if (this.mainBundleConfig && this.data.productsConfiguration?.length > 0) {
      await updateConfigOptions();
    }

    if (this.data.productsBundle?.length > 0) {
      response = await storefront.request({
        query: queries.products,
        variables: {
          ids: this.data.productsBundle.map((item) =>
            encodeId(item.id, "Product"),
          ),
        },
      });
    } else {
      response = await storefront.request({
        query: queries.product,
        variables: {
          handle: this.data.product.handle,
        },
      });
    }

    const MainMedia = () => {
      return <MediaContent data={this.data} />;
    };
    const MainVariant = () => {
      return (
        <VariantPickerContent
          data={response.data.productByHandle}
          form={this.productForm}
          group={this.groupSet}
        />
      );
    };

    const MainBundle = () => {
      return (
        <BundlePickerContent
          data={this.data}
          form={this.productForm}
          group={this.groupSet}
          bundle={response?.data.nodes}
          parent={this.mainBundle}
        />
      );
    };

    const MainBundleConfig = () => {
      return (
        <BundleConfigContent
          data={this.data}
          form={this.productForm}
          group={this.groupSet}
          bundle={configOptions.data.nodes}
          parent={this.mainBundle}
        />
      );
    };

    render(<MainMedia />, this.mainMedia);
    this.mainBundleConfig &&
      render(<MainBundleConfig />, this.mainBundleConfig);
    this.mainBundle && render(<MainBundle />, this.mainBundle);
    this.mainVariant && render(<MainVariant />, this.mainVariant);

    document.addEventListener("refreshComponents", (e) => {
      setTimeout(async () => {
        this.data = scrapeSectionData(this);
        await updateConfigOptions();
        this.mainBundleConfig = this.querySelector(
          "[data-bundle-configuration-container]",
        );
        render(<MainBundleConfig />, this.mainBundleConfig);
      }, 500);
    });
  };
}

if (!customElements.get("section-product")) {
  customElements.define("section-product", SectionProduct);
}
